module.exports = __webpack_public_path__ + "img/administrators.fbb2d921.png";